import { formatMoney } from '@theme/money-formatting';

function syncLineTotal(root) {
  const unitPrice = Number.parseInt(root.dataset.unitPrice || '', 10);
  const format = root.dataset.moneyFormat || '{{amount}}';
  const currency = root.dataset.currency || 'USD';
  const input = root.querySelector('input[name="quantity"]');
  const totalEl = root.querySelector('[data-uucck-line-total]');
  if (!input || !totalEl || Number.isNaN(unitPrice)) return;

  const qty = Math.max(1, Number.parseInt(input.value, 10) || 1);
  const formatted = formatMoney(unitPrice * qty, format, currency);
  totalEl.textContent = formatted;
  totalEl.title = formatted;
}

function bindRoot(root) {
  if (root.dataset.uucckVaultBound === 'true') return;
  root.dataset.uucckVaultBound = 'true';

  const input = root.querySelector('input[name="quantity"]');
  if (!input) return;

  const run = () => syncLineTotal(root);
  input.addEventListener('input', run);
  input.addEventListener('change', run);
  root.querySelectorAll('.quantity-minus, .quantity-plus').forEach((btn) => {
    btn.addEventListener('click', () => window.requestAnimationFrame(run));
  });
  run();
}

function init() {
  document.querySelectorAll('uucck-vault-catalog-actions').forEach(bindRoot);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
